import { ConfirmedEnum } from '../../../../types/inventory';
import type { OrderItemV2 } from '../../../../types/inventoryV2';
import type { RequirementDetailType } from './hooks/useGetDetail';
import type { OutQtyObj } from './components/PreOutOrderPrint';

export function updateCheckedItems<T extends { id: string; checked?: boolean }>(
  items: T[], ids: ReadonlySet<string>, checked: boolean,
): T[] {
  let changed = false;
  const next = items.map(item => {
    if (!ids.has(item.id) || !!item.checked === checked) return item;
    changed = true;
    return { ...item, checked };
  });
  return changed ? next : items;
}

// 订单数量单独汇总，勾选物料时可以直接复用。
export function sumPendingOrderQuantities(orderItems: OrderItemV2[]): Map<string, number> {
  const quantities = new Map<string, number>();
  orderItems.forEach(item => {
    if (item.order.confirmState === ConfirmedEnum.CONFIRM) return;
    const quantity = Number(item.count || 0) || 0;
    quantities.set(item.sourceId, (quantities.get(item.sourceId) ?? 0) + quantity);
  });
  return quantities;
}

export function buildPreOutQtyMap(
  items: RequirementDetailType[], pendingQuantities: ReadonlyMap<string, number>,
): Record<string, OutQtyObj> {
  const quantities: Record<string, OutQtyObj> = {};
  items.forEach(item => {
    quantities[item.id] = {
      preOutQty: pendingQuantities.get(item.id) ?? 0,
      outQty: Number(item.outCount || ''),
      useAmount: Number(item.useAmount || '') || 0,
      bomAmount: Number(item.bomAmount || '') || 0,
    };
  });
  return quantities;
}
